import http from "../../axiosSetup";
import FileService from "../FileService";

class ExportService {
  /**
   * @param {any} options
   */
  static exportAthletes({
    athleteIds,
    startDate,
    endDate,
    splitExercises,
    exerciseIds,
    includeHeight,
    includeWeight,
    includeWellness,
    includeEmail,
    includeSex,
    includeGroups,
    includeSports,
  }) {
    return http
      .post(
        "/export/athletes",
        {
          athleteIds,
          startDate,
          endDate,
          splitExercises,
          exerciseIds,
          includeHeight,
          includeWeight,
          includeWellness,
          includeEmail,
          includeSex,
          includeGroups,
          includeSports,
        },
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then(FileService.downloadResponseAsZip);
  }
}
export default ExportService;
